import Header from "@/components/Header";
import Hero from "@/components/sections/Hero";
import MarqueeStrip from "@/components/sections/MarqueeStrip";
import About from "@/components/sections/About";
import VisionMission from "@/components/sections/VisionMission";
import Services from "@/components/sections/Services";
import Products from "@/components/sections/Products";
import Partners from "@/components/sections/Partners";
import Roadmap from "@/components/sections/Roadmap";
import Process from "@/components/sections/Process";
import Leadership from "@/components/sections/Leadership";
import WhyChoose from "@/components/sections/WhyChoose";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-white text-ink-primary font-body">
      <Header />
      <Hero />
      <MarqueeStrip />
      <About />
      <VisionMission />
      <Services />
      <Products />
      <Partners />
      <Roadmap />
      <Process />
      <WhyChoose />
      <Leadership />
      <Contact />
      <Footer />
    </main>
  );
}
